export type Points = {
  icon: string;
  copy: {
    title: string;
    description: string;
  };
}[];

export enum ACTION_BUTTON_TYPE {
  LEARN_MORE = "learn-more",
  FIND_DEALER = "find-dealer"
}

export const BUTTON_TEXT_MAPPING = {
  [ACTION_BUTTON_TYPE.LEARN_MORE]: "commons.learnMore",
  [ACTION_BUTTON_TYPE.FIND_DEALER]: "commons.locateAuthorized",
} as const satisfies Record<ACTION_BUTTON_TYPE, string>;

export type MainSection = {
  imgFirst?: true;
  customWhiteSpaceTop?: number;
  header: {
    title: string;
    description: string;
  };
  img: {
    src: string;
    alt: string;
  };
  points?: Points;
  customPoints?: {
    description: string;
    header: string;
    points: {
      category: string;
      qualifiedProducts: string;
    }[];
  };
  buttonLink: string;
  buttonType: ACTION_BUTTON_TYPE;
  disclaimer?: string;
};

export type ResourceCard = {
  icon: string;
  title: string;
  link: {
    text: string;
    href: string;
  };
};
